<template>
    <div class="col-12 mx-auto">
        <div class="card">
            <div class="card-header bg-primary text-white">
                <page-title :title="$t('reportData.participants.pageTitle')" :showTitle="false"></page-title>
                <div class="card-title h5 m-0">
                    {{ $t('reportData.participants.pageTitle') }}
                </div>
            </div>

            <div class="card-header" v-if="showReportDataParticipantsSettings">
                <span v-if="showReportDataParticipantsSettings">
                    <i class="fas fa-cogs pointer fa-2x float-right text-primary"
                       @click.stop="changeGridSettings('reportDataParticipantsGrid')"
                       data-toggle="tooltip"
                       :title="$t('buttons.settings.tooltipText')"></i>
                </span>

                <div v-if="showReportDataParticipantsSettings">
                    <GridUserSettings ref="reportDataParticipantsSettings"
                                      :visible="showReportDataParticipantsSettingsForm"
                                      :grid="$refs['reportDataParticipantsGrid']"
                                      :componentName="componentName">
                    </GridUserSettings>
                </div>
            </div>

            <div class="card-body">
                <div class="btn-toolbar justify-content-between mt-0 mb-2" role="toolbar">
                    <div class="form-inline col-6">

                    </div>

                    <div class="input-group">
                        <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                        <button class="btn btn-secondary" @click.stop="massSearch">
                            <i class="fas fa-search"></i>
                            {{ $t('buttons.search.btnText') }}
                        </button>
                        <button class="btn btn-secondary"
                                @click.stop="clearFilters">
                            <i class="fas fa-times"></i>
                            {{ $t('buttons.clearFilters.btnText') }}
                        </button>
                    </div>
                </div>

                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size='gridOptions.pageable.size'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError">
                </kendo-datasource>

                <kendo-grid ref="reportDataParticipantsGrid"
                            :data-source-ref="'datasource1'"
                            :navigatable="gridOptions.navigatable"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :toolbar="gridOptions.toolbar"
                            :dataBound="dataBound"
                            :excel="gridOptions.excel"
                            name="reportDataParticipantsGrid">


                    <kendo-grid-column :template="btnsTemplate"
                                       field="btnsColumn"
                                       :title="$t('actions')"
                                       :filterable="false"
                                       :sortable="false"
                                       v-if="showBtns && (hasEventReadRights || hasParticipantReadRights)"
                                       :width="150"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'id'"
                                       :title="$t('reportData.participants.participantId')"
                                       :width="100"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participationTypeName'"
                                       :title="$t('reportData.participants.participationTypeName')"
                                       :width="150"
                                       :hidden="isEnVersion"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participationTypeNameEn'"
                                       :title="$t('reportData.participants.participationTypeName')"
                                       :width="150"
                                       :hidden="!isEnVersion"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'title'"
                                       :title="$t('reportData.participants.title')"
                                       :width="130"
                                       :hidden="isEnVersion"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'titleEn'"
                                       :title="$t('reportData.participants.title')"
                                       :width="130"
                                       :hidden="!isEnVersion"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'fullName'"
                                       :title="$t('reportData.participants.fullName')"
                                       :width="250"
                                       :hidden="isEnVersion"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'fullNameEn'"
                                       :title="$t('reportData.participants.fullName')"
                                       :width="250"
                                       :hidden="!isEnVersion"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'registerEntityId'"
                                       :title="$t('reportData.participants.registerEntityId')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventName'"
                                       :title="$t('reportData.events.eventName')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventCode'"
                                       :title="$t('reportData.events.eventCode')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'shortDates'"
                                       :title="$t('reportData.events.shortDates')"
                                       :width="200"
                                       :sortable="false"
                                       :filterable="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'position'"
                                       :title="$t('reportData.participants.position')"
                                       :width="200"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'positionEn'"
                                       :title="$t('reportData.participants.position')"
                                       :width="200"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'positionStatistics'"
                                       :title="$t('reportData.participants.positionStatistics')"
                                       :width="300"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'positionStatisticsEn'"
                                       :title="$t('reportData.participants.positionStatistics')"
                                       :width="300"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'positionStr'"
                                       :title="$t('reportData.participants.positionFullName')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'institutionName'"
                                       :title="$t('reportData.participants.institutionName')"
                                       :width="250"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'institutionNameEn'"
                                       :title="$t('reportData.participants.institutionName')"
                                       :width="250"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'institutionCity'"
                                       :title="$t('reportData.participants.institutionCity')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'areaOfAppealName'"
                                       :title="$t('reportData.participants.areaOfAppeal')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participationName'"
                                       :title="$t('reportData.participants.participationName')"
                                       :width="300"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participationNameEn'"
                                       :title="$t('reportData.participants.participationName')"
                                       :width="300"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'email'"
                                       :title="$t('reportData.participants.email')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'phone'"
                                       :title="$t('reportData.participants.phone')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'mobilePhone'"
                                       :title="$t('reportData.participants.mobilePhone')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'salutation'"
                                       :title="$t('reportData.participants.salutation')"
                                       :width="200"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'salutationEn'"
                                       :title="$t('reportData.participants.salutation')"
                                       :width="200"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'gender'"
                                       :title="$t('reportData.participants.gender')"
                                       :width="150"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'genderEn'"
                                       :title="$t('reportData.participants.gender')"
                                       :width="150"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'egn'"
                                       :title="$t('reportData.participants.egn')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'firstName'"
                                       :title="$t('reportData.participants.firstName')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'middleName'"
                                       :title="$t('reportData.participants.middleName')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'lastName'"
                                       :title="$t('reportData.participants.lastName')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'reasonForAdmission'"
                                       :title="$t('reportData.participants.reasonForAdmission')"
                                       :width="300"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'reasonForAdmissionEn'"
                                       :title="$t('reportData.participants.reasonForAdmission')"
                                       :width="300"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'statusName'"
                                       :title="$t('reportData.participants.statusName')"
                                       :width="300"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'statusNameEn'"
                                       :title="$t('reportData.participants.statusName')"
                                       :width="300"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'deployed'"
                                       :title="$t('reportData.participants.deployed')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'cityOfCurrentAddress'"
                                       :title="$t('reportData.participants.cityOfCurrentAddress')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'employment'"
                                       :title="$t('reportData.participants.employment')"
                                       :width="200"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'employmentEn'"
                                       :title="$t('reportData.participants.employment')"
                                       :width="200"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'education'"
                                       :title="$t('reportData.participants.education')"
                                       :width="200"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'educationEn'"
                                       :title="$t('reportData.participants.education')"
                                       :width="200"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'partRequsetFillDate'"
                                       :title="$t('reportData.participants.partRequsetFillDate')"
                                       :width="300"
                                       :format="customDateTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'accommodationRequest'"
                                       :title="$t('reportData.participants.accommodationRequest')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'datesForNights'"
                                       :title="$t('reportData.participants.datesForNights')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'roomType'"
                                       :title="$t('reportData.participants.roomType')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'travelers'"
                                       :title="$t('reportData.participants.travelers')"
                                       :width="200"
                                       :template="travelersCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'vegetarianMenu'"
                                       :title="$t('reportData.participants.vegetarianMenu')"
                                       :width="200"
                                       :template="menuCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'note'"
                                       :title="$t('reportData.participants.note')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isMigrant'"
                                       :title="$t('reportData.participants.isMigrant')"
                                       :width="150"
                                       :template="migrantCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isForeigner'"
                                       :title="$t('reportData.participants.isForeigner')"
                                       :width="150"
                                       :template="foreignerCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isMemberOfAMinority'"
                                       :title="$t('reportData.participants.isMemberOfAMinority')"
                                       :width="170"
                                       :template="minorityCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isOfGypsyOrigin'"
                                       :title="$t('reportData.participants.isOfGypsyOrigin')"
                                       :width="150"
                                       :template="gipsyCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'withDisabilities'"
                                       :title="$t('reportData.participants.withDisabilities')"
                                       :width="170"
                                       :template="disabilitiesCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isHomeless'"
                                       :title="$t('reportData.participants.isHomeless')"
                                       :width="170"
                                       :template="homelessCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isDisadvantaged'"
                                       :title="$t('reportData.participants.isDisadvantaged')"
                                       :width="200"
                                       :template="disadvantagedCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isFromUnemployedHousehold'"
                                       :title="$t('reportData.participants.isFromUnemployedHousehold')"
                                       :width="170"
                                       :template="unemployedHouseHoldCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'withDependentChildren'"
                                       :title="$t('reportData.participants.withDependentChildren')"
                                       :width="170"
                                       :template="childrenCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'fromOneMemberHousehold'"
                                       :title="$t('reportData.participants.fromOneMemberHousehold')"
                                       :width="170"
                                       :template="oneMemberCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'createdByUserName'"
                                       :title="$t('reportData.participants.createdByUserName')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'createdAt'"
                                       :title="$t('reportData.participants.createdAt')"
                                       :width="200"
                                       :format="customDateTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'updatedByUserName'"
                                       :title="$t('reportData.participants.updatedByUserName')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'updatedAt'"
                                       :title="$t('reportData.participants.updatedAt')"
                                       :width="200"
                                       :format="customDateTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'consentToBeProcessed'"
                                       :title="$t('reportData.participants.consentToBeProcessed')"
                                       :width="200"
                                       :template="consentCellTemplate">
                    </kendo-grid-column>
                    <!--<kendo-grid-column :field="'participationCode'"
                       :title="$t('reportData.participants.participationCode')"
                       :width="200">
    </kendo-grid-column>-->
                    <kendo-grid-column :field="'participantMigrationId'"
                                       :title="$t('reportData.participants.participantMigrationId')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventMigrationId'"
                                       :title="$t('reportData.participants.eventMigrationId')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationInstitutionName'"
                                       :title="$t('reportData.participants.migrationInstitutionName')"
                                       :width="250">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationInstitutionCity'"
                                       :title="$t('reportData.participants.migrationInstitutionCity')"
                                       :width="250">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventVenue'"
                                       :title="$t('reportData.events.eventVenue')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLocation'"
                                       :title="$t('reportData.events.eventLocation')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventMainActivity'"
                                       :title="$t('reportData.events.eventMainActivity')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventDirectorate'"
                                       :title="$t('reportData.events.eventDirectorate')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventActivityDirection'"
                                       :title="$t('reportData.events.eventActivityDirection')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventSort'"
                                       :title="$t('reportData.events.eventSort')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventFundingType'"
                                       :title="$t('reportData.events.eventFundingType')"
                                       :width="400">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventProjectName'"
                                       :title="$t('reportData.events.eventProjectName')"
                                       :width="400">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventForm'"
                                       :title="$t('reportData.events.eventForm')"
                                       :width="170">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventOrganizerName'"
                                       :title="$t('reportData.events.eventOrganizerName')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStartDate'"
                                       :title="$t('reportData.events.eventStartDate')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStartDate'"
                                       :title="$t('reportData.events.eventStartDateHour')"
                                       :width="150"
                                       :format="customTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventEndDate'"
                                       :title="$t('reportData.events.eventEndDate')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventEndDate'"
                                       :title="$t('reportData.events.eventEndDateHour')"
                                       :width="150"
                                       :format="customTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLegalArea'"
                                       :title="$t('reportData.events.eventLegalArea')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'thematicArea'"
                                       :title="$t('reportData.events.thematicArea')"
                                       :width="500">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStatus'"
                                       :title="$t('reportData.events.eventStatus')"
                                       :width="200"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStatusEn'"
                                       :title="$t('reportData.events.eventStatus')"
                                       :width="200"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventDescription'"
                                       :title="$t('reportData.events.eventDescription')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventExpectedResults'"
                                       :title="$t('reportData.events.eventExpectedResults')"
                                       :width="400">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLearningGoals'"
                                       :title="$t('reportData.events.eventLearningGoals')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventContactPerson'"
                                       :title="$t('reportData.events.eventContactPerson')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLabel'"
                                       :title="$t('reportData.events.eventLabel')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'excludeFromReporting'"
                                       :title="$t('reportData.events.excludeFromReporting')"
                                       :width="200"
                                       :template="excludeCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'deleted'"
                                       :title="$t('reportData.participants.deleted')"
                                       :width="170"
                                       :template="deletedCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'archived'"
                                       :title="$t('reportData.events.archived')"
                                       :width="170"
                                       :template="archivedCellTemplate">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>

        <DetailsModal v-model="detailsModel" :show="showDetails" @onClose="onDetailsClose"></DetailsModal>
        <ParticipantDetailsModal v-model="participantDetailsModel" :show="showParticipantDetails" @onClose="onParticipantDetailsClose"></ParticipantDetailsModal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import GridUserSettings from '../../components/grid/GridSettingsWrapper';
    import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
    import PageTitle from '../../components/common/PageTitle';
    import { RegisterFieldValueQueryFilter } from '../../models/enums';
    import DetailsModal from '../../components/dynamic/register/details.modal';
    import ParticipantDetailsModal from '../../components/participants/details.modal';
    import { mapGetters } from 'vuex'

    export default {
        name: 'ParticipantsReportDataGrid',
        components: {
            GridUserSettings,
            PageTitle,
            DetailsModal,
            ParticipantDetailsModal
        },
        props: {
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                componentName: "participantsReportData",
                titleKey: 'reportData.participants.pageTitle',
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                customSettingsLoaded: false,
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: true, visible: true },
                    participantMigrationId: { name: 'participantMigrationId', type: 'number', editable: false, nullable: true, visible: true },
                    registerEntityId: { name: 'registerEntityId', type: 'number', editable: false, nullable: true, visible: true },
                    eventMigrationId: { name: 'eventMigrationId', type: 'number', editable: false, nullable: true, visible: true },
                    partRequsetFillDate: { name: 'partRequsetFillDate', type: 'date', editable: false, nullable: true, visible: true },
                    gender: { name: 'gender', type: 'string', editable: false, nullable: true, visible: true },
                    genderEn: { name: 'genderEn', type: 'string', editable: false, nullable: true, visible: true },
                    title: { name: 'title', type: 'string', editable: false, nullable: true, visible: true },
                    titleEn: { name: 'titleEn', type: 'string', editable: false, nullable: true, visible: true },
                    salutation: { name: 'salutation', type: 'string', editable: false, nullable: true, visible: true },
                    salutationEn: { name: 'salutationEn', type: 'string', editable: false, nullable: true, visible: true },
                    egn: { name: 'egn', type: 'string', editable: false, nullable: true, visible: true },
                    fullName: { name: 'fullName', type: 'string', editable: false, nullable: true, visible: true },
                    fullNameEn: { name: 'fullNameEn', type: 'string', editable: false, nullable: true, visible: true },
                    firstName: { name: 'firstName', type: 'string', editable: false, nullable: true, visible: true },
                    middleName: { name: 'middleName', type: 'string', editable: false, nullable: true, visible: true },
                    lastName: { name: 'lastName', type: 'string', editable: false, nullable: true, visible: true },
                    position: { name: 'position', type: 'string', editable: false, nullable: true, visible: true },
                    positionEn: { name: 'positionEn', type: 'string', editable: false, nullable: true, visible: true },
                    migrationInstitutionName: { name: 'migrationInstitutionName', type: 'string', editable: false, nullable: true, visible: true },
                    migrationInstitutionCity: { name: 'migrationInstitutionCity', type: 'string', editable: false, nullable: true, visible: true },
                    institutionName: { name: 'institutionName', type: 'string', editable: false, nullable: true, visible: true },
                    institutionNameEn: { name: 'institutionNameEn', type: 'string', editable: false, nullable: true, visible: true },
                    institutionCity: { name: 'institutionCity', type: 'string', editable: false, nullable: true, visible: true },
                    areaOfAppealName: { name: 'areaOfAppealName', type: 'string', editable: false, nullable: true, visible: true },
                    phone: { name: 'phone', type: 'string', editable: false, nullable: true, visible: true },
                    mobilePhone: { name: 'mobilePhone', type: 'string', editable: false, nullable: true, visible: true },
                    email: { name: 'email', type: 'string', editable: false, nullable: true, visible: true },
                    participationCode: { name: 'participationCode', type: 'number', editable: false, nullable: true, visible: true },
                    participationName: { name: 'participationName', type: 'string', editable: false, nullable: true, visible: true },
                    participationNameEn: { name: 'participationNameEn', type: 'string', editable: false, nullable: true, visible: true },
                    reasonForAdmission: { name: 'reasonForAdmission', type: 'string', editable: false, nullable: true, visible: true },
                    reasonForAdmissionEn: { name: 'reasonForAdmissionEn', type: 'string', editable: false, nullable: true, visible: true },
                    deployed: { name: 'deployed', type: 'string', editable: false, nullable: true, visible: true },
                    cityOfCurrentAddress: { name: 'cityOfCurrentAddress', type: 'string', editable: false, nullable: true, visible: true },
                    accommodationRequest: { name: 'accommodationRequest', type: 'string', editable: false, nullable: true, visible: true },
                    datesForNights: { name: 'datesForNights', type: 'string', editable: false, nullable: true, visible: true },
                    roomType: { name: 'roomType', type: 'string', editable: false, nullable: true, visible: true },
                    travelers: { name: 'travelers', type: 'boolean', editable: false, nullable: true, visible: true },
                    vegetarianMenu: { name: 'vegetarianMenu', type: 'boolean', editable: false, nullable: true, visible: true },
                    note: { name: 'note', type: 'string', editable: false, nullable: true, visible: true },
                    positionStatistics: { name: 'positionStatistics', type: 'string', editable: false, nullable: true, visible: true },
                    positionStatisticsEn: { name: 'positionStatisticsEn', type: 'string', editable: false, nullable: true, visible: true },
                    isMigrant: { name: 'isMigrant', type: 'boolean', editable: false, nullable: true, visible: true },
                    isForeigner: { name: 'isForeigner', type: 'boolean', editable: false, nullable: true, visible: true },
                    isMemberOfAMinority: { name: 'isMemberOfAMinority', type: 'boolean', editable: false, nullable: true, visible: true },
                    isOfGypsyOrigin: { name: 'isOfGypsyOrigin', type: 'boolean', editable: false, nullable: true, visible: true },
                    withDisabilities: { name: 'withDisabilities', type: 'boolean', editable: false, nullable: true, visible: true },
                    isHomeless: { name: 'isHomeless', type: 'boolean', editable: false, nullable: true, visible: true },
                    isDisadvantaged: { name: 'isDisadvantaged', type: 'boolean', editable: false, nullable: true, visible: true },
                    isFromUnemployedHousehold: { name: 'isFromUnemployedHousehold', type: 'boolean', editable: false, nullable: true, visible: true },
                    withDependentChildren: { name: 'withDependentChildren', type: 'boolean', editable: false, nullable: true, visible: true },
                    fromOneMemberHousehold: { name: 'fromOneMemberHousehold', type: 'boolean', editable: false, nullable: true, visible: true },
                    createdByUserName: { name: 'createdByUserName', type: 'string', editable: false, nullable: true, visible: true },
                    createdAt: { name: 'createdAt', type: 'date', editable: false, nullable: true, visible: true },
                    updatedByUserName: { name: 'updatedByUserName', type: 'string', editable: false, nullable: true, visible: true },
                    updatedAt: { name: 'updatedAt', type: 'date', editable: false, nullable: true, visible: true },
                    employment: { name: 'employment', type: 'string', editable: false, nullable: true, visible: true },
                    employmentEn: { name: 'employmentEn', type: 'string', editable: false, nullable: true, visible: true },
                    education: { name: 'education', type: 'string', editable: false, nullable: true, visible: true },
                    educationEn: { name: 'educationEn', type: 'string', editable: false, nullable: true, visible: true },
                    consentToBeProcessed: { name: 'consentToBeProcessed', type: 'boolean', editable: false, nullable: true, visible: true },
                    participationTypeName: { name: 'participationTypeName', type: 'string', editable: false, nullable: true, visible: true },
                    participationTypeNameEn: { name: 'participationTypeNameEn', type: 'string', editable: false, nullable: true, visible: true },
                    statusName: { name: 'statusName', type: 'string', editable: false, nullable: true, visible: true },
                    positionStr: { name: 'positionStr', type: 'string', editable: false, nullable: true, visible: true },
                    eventName: { name: 'eventName', type: 'string', editable: false, nullable: true, visible: true },
                    eventCode: { name: 'eventCode', type: 'string', editable: false, nullable: true, visible: true },
                    eventStartDate: { name: 'eventStartDate', type: 'date', editable: false, nullable: true, visible: true },
                    eventEndDate: { name: 'eventEndDate', type: 'date', editable: false, nullable: true, visible: true },
                    eventVenue: { name: 'eventVenue', type: 'string', editable: false, nullable: true, visible: true },
                    eventLocation: { name: 'eventLocation', type: 'string', editable: false, nullable: true, visible: true },
                    eventMainActivity: { name: 'eventMainActivity', type: 'string', editable: false, nullable: true, visible: true },
                    eventDirectorate: { name: 'eventDirectorate', type: 'string', editable: false, nullable: true, visible: true },
                    eventActivityDirection: { name: 'eventActivityDirection', type: 'string', editable: false, nullable: true, visible: true },
                    eventLegalArea: { name: 'eventLegalArea', type: 'string', editable: false, nullable: true, visible: true },
                    eventFundingType: { name: 'eventFundingType', type: 'string', editable: false, nullable: true, visible: true },
                    eventProjectName: { name: 'eventProjectName', type: 'string', editable: false, nullable: true, visible: true },
                    eventOrganizerName: { name: 'eventOrganizerName', type: 'string', editable: false, nullable: true, visible: true },
                    eventSort: { name: 'eventSort', type: 'string', editable: false, nullable: true, visible: true },
                    eventForm: { name: 'eventForm', type: 'string', editable: false, nullable: true, visible: true },
                    thematicArea: { name: 'thematicArea', type: 'string', editable: false, nullable: true, visible: true },
                    eventStatus: { name: 'eventStatus', type: 'string', editable: false, nullable: true, visible: true },
                    eventStatusEn: { name: 'eventStatusEn', type: 'string', editable: false, nullable: true, visible: true },
                    eventDescription: { name: 'eventDescription', type: 'string', editable: false, nullable: true, visible: true },
                    eventExpectedResults: { name: 'eventExpectedResults', type: 'string', editable: false, nullable: true, visible: true },
                    eventLearningGoals: { name: 'eventLearningGoals', type: 'string', editable: false, nullable: true, visible: true },
                    excludeFromReporting: { name: 'excludeFromReporting', type: 'boolean', editable: false, nullable: true, visible: true },
                    archived: { name: 'archived', type: 'boolean', editable: false, nullable: true, visible: true },
                    deleted: { name: 'deleted', type: 'boolean', editable: false, nullable: true, visible: true },

                    eventContactPerson: { name: 'eventContactPerson', type: 'string', editable: false, nullable: true, visible: true },
                    eventLabel: { name: 'eventLabel', type: 'string', editable: false, nullable: true, visible: true },
                    eventLabelEn: { name: 'eventLabelEn', type: 'string', editable: false, nullable: true, visible: true },
                },
                transportSettings: {
                    read: {
                        url: `${this.$store.getters.baseUrl}/api/reportData/nipParticipants`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    toolbar: ['excel'],
                    excel: {
                        fileName: 'NIPParticipants.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                },
                showReportDataParticipantsSettings: false,
                showReportDataParticipantsSettingsForm: false,
                searchQuery: '',
                selectedEventFilter: '',
                detailsModel: null,
                showDetails: false,
                participantDetailsModel: null,
                showParticipantDetails: false,
            }
        },
        computed: {
            ...mapGetters(['timeFormat', 'dateFormat', 'dateTimeFormat', 'isEnVersion', 'authToken']),
            customTimeFormat() {
                return `{0:${this.timeFormat}}`
            },
            customDateFormat() {
                return `{0:${this.dateFormat}}`
            },
            customDateTimeFormat() {
                return `{0:${this.dateTimeFormat}}`
            },
            hasEventReadRights() {
                return this.$store.getters.claims.event.read;
            },
            hasParticipantReadRights() {
                return this.$store.getters.claims.participant.read;
            },
            token: function () {
                return this.authToken;
            },
            selectedEventFilterId() {
                let id = Number(this.selectedEventFilter);
                return isNaN(id) ? 0 : id;
            }
        },
        created: function () {
            window.JSZip = JSZip
        },
        mounted: function () {
            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        methods: {
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            dataBound(e) {
                if (e.sender.options.dataSourceRef === 'datasource1' && !this.showReportDataParticipantsSettings) {
                    this.showReportDataParticipantsSettings = true;
                }
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    this.saveState();
                    return kendo.stringify(options);
                }
            },
            saveState: function () {
                let grid = this.$refs.reportDataParticipantsGrid.kendoWidget();

                localStorage["participants-reportdata-grid-options"] = kendo.stringify(grid.getOptions());
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            toolbarTemplate: function () {
                let templateHtml =
                    '<span>' +
                    '<a class="k-pager-refresh k-link k-button" title="Refresh"><span class="k-icon k-i-reload"></span></a>' +
                    '</span>';

                return kendo.template(templateHtml);
            },
            travelersCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.travelers ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.travelers ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            menuCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.vegetarianMenu ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.vegetarianMenu ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            migrantCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isMigrant ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isMigrant ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            foreignerCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isForeigner ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isForeigner ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            minorityCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isMemberOfAMinority ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isMemberOfAMinority ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            gipsyCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isOfGypsyOrigin ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isOfGypsyOrigin ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            disabilitiesCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.withDisabilities ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.withDisabilities ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            homelessCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isHomeless ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isHomeless ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            disadvantagedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isDisadvantaged ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isDisadvantaged ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            unemployedHouseHoldCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isFromUnemployedHousehold ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isFromUnemployedHousehold ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            childrenCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.withDependentChildren ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.withDependentChildren ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            oneMemberCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.fromOneMemberHousehold ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.fromOneMemberHousehold ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            consentCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.consentToBeProcessed ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.consentToBeProcessed ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            yesNoCellTemplate: function (dataItemField) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItemField ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItemField ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            excludeCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.excludeFromReporting ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.excludeFromReporting ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            archivedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.archived ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.archived ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            deletedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.deleted ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.deleted ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.reportDataParticipantsGrid,
                         btns: [{
                            name: "eventDetails",
                            text: "",
                            tooltip: this.$t('buttons.eventDetails.btnText'),
                            class: 'btn btn-primary',
                            icon: "fas fa-eye",
                            show: true,
                            clickHandler: this.eventDetailsBtnClick
                         },
                             {
                            name: "participantDetails",
                            text: "",
                            tooltip: this.$t('buttons.participantDetails.btnText'),
                            class: 'btn btn-primary',
                            icon: "fas fa-eye",
                            show: true,
                            clickHandler: this.participantDetailsBtnClick
                         },
                        ]
                    }
                };
            },
            eventDetailsBtnClick(args) {
                this.showEventDetailsModal(args, RegisterFieldValueQueryFilter.All);
            },
            showEventDetailsModal(args, filter) {
                this.$api.dynamicRegister
                    .getDetails(args.registerEntityId, filter)
                    .then(response => {
                        const model = response.data;
                        if (model) {
                            this.detailsModel = model;
                            this.showDetails = true;
                        }
                    })
                    .catch(error => {
                        this.detailsModel = null;
                        this.showDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onDetailsClose() {
                this.showDetails = false;
                this.detailsModel = null;
            },
            participantDetailsBtnClick(args) {
                this.showParticipantDetailsModal(args);
            },
            showParticipantDetailsModal(args) {
                this.$api.participant
                    .get(args.id)
                    .then(response => {
                        const model = response.data;
                        if (model) {
                            this.participantDetailsModel = model;
                            this.showParticipantDetails = true;
                        }
                    })
                    .catch(error => {
                        this.participantDetailsModel = null;
                        this.showParticipantDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onParticipantDetailsClose() {
                this.showParticipantDetails = false;
                this.participantDetailsModel = null;
            },
            changeGridSettings(gridName) {
                if (gridName === 'reportDataParticipantsGrid') {
                    this.showReportDataParticipantsSettingsForm = !this.showReportDataParticipantsSettingsForm;
                }
            },
            refresh() {
                this.$refs['reportDataParticipantsGrid'].kendoWidget().dataSource.read();
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.reportDataParticipantsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.reportDataParticipantsGrid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            excelExport() {
                let id = this.selectedEventFilterId;

                this.$http.get('/api/reportData/participantsExcelExport/' + id, { responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', this.registerName + '.xlsx'); // or any other extension
                        document.body.appendChild(link);
                        link.click();
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            }
        }
    }
</script>

<style scoped>
    .btn {
        margin-right: 10px;
        margin-left: 5px;
    }

    .checkbox {
        margin-right: 5px;
    }

    .selectFile {
        display: none;
    }

    .inlineForm {
        display: inline;
    }
</style>

<style lang="scss">
    .grid-wrapper {
        overflow-x: auto;
    }

    tr.left-border-danger {
        &:hover

    {
        color: rgba(255, 0, 0, 0.7) !important;
    }

    td:first-child {
        border-left: 3px solid rgba(255, 0, 0, 0.5) !important;
    }

    }

    tr.left-border-blue {
        &:hover

    {
        color: #3498db !important;
    }

    td:first-child {
        border-left: 4px solid #3498db !important;
    }

    }

    tr.left-border-green {
        &:hover

    {
        color: #4caf50 !important;
    }

    td:first-child {
        border-left: 4px solid #4caf50 !important;
    }

    }

    tr.left-border-secondary {
        &:hover

    {
        color: #707a8a !important;
    }

    td:first-child {
        border-left: 4px solid #707a8a !important;
    }

    }

    .k-grid td {
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
